<template>
  <v-card min-height="550">
    <v-row width="100%">
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.animalOrigin')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.countryOriginAnimal')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.animalOrigin
                      ? currentAnimal.animalOrigin == 'purchased'? 'Purchased' : 'Born On Farm'
                      :  $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('farmOfOrigin')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('farmOfOriginH')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.originFarmNo
                      ? currentAnimal.originFarmNo
                      :  $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.currentOwner')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.nameOfOwnerAnimal')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.ownerName
                      ? currentAnimal.ownerName
                      :  $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <template>
      <div class="table-section">
        <v-data-table
          :headers="headers"
          :items="desserts"
          :items-per-page="5"
          class="mt-10"
          hide-default-footer
        >
          <template v-slot:footer> </template>
        </v-data-table>
      </div>
    </template>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  created() {},
  computed: {
    ...mapGetters(["currentAnimal"]),
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('animal.registrationDate'),
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: this.$t('animal.previousOwner'), value: "calories" },
        { text: this.$t('animal.nameOfOperator'), value: "fat" },
      ],
      desserts: [
        // {
        //   name: "12/06/2020",
        //   calories: "Name of Previous Owner",
        //   fat: "Operator Name",
        // },
        // {
        //   name: "13/12/2019",
        //   calories: "Name of Previous Owner",
        //   fat: "Operator Name",
        // },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  color: black;
}
</style>